import { render, staticRenderFns } from "./BenchmarkingDashboard.vue?vue&type=template&id=46d5f8b2&scoped=true&"
import script from "./BenchmarkingDashboard.vue?vue&type=script&lang=js&"
export * from "./BenchmarkingDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d5f8b2",
  null
  
)

export default component.exports